<div class="layout-col full">
  <!-- Header Section -->
  <div class="layout-row">
    @if (embedded) {
      <div class="flex layout-row place-start-center gap-md p-lg">
        <ng-template [ngTemplateOutlet]="header"></ng-template>
      </div>
    } @else {
      <mat-toolbar elderTheme class="gap-md">
        <button mat-icon-button (click)="onClose($event)">
          <mat-icon>close</mat-icon>
        </button>
        <ng-template [ngTemplateOutlet]="header"></ng-template>
      </mat-toolbar>
    }
  </div>

  <elder-single-pane-wrapper class="flex">
    <elder-pane-content>
      @if (groupTracedMaterials$ | async) {
        <app-traced-material-grouped
          class="flex"
          [tracedMaterials]="tracedMaterials$ | async"
          (updates)="onTracingConfigUpdates($event)"
        >
        </app-traced-material-grouped>
      } @else {
        <app-traced-material-single
          class="flex"
          [tracedMaterials]="tracedMaterials$ | async"
          (updates)="onTracingConfigUpdates($event)"
        >
        </app-traced-material-single>
      }
    </elder-pane-content>
  </elder-single-pane-wrapper>
</div>

<ng-template #header>
  <div class="flex layout-row gap-md place-start-center">
    <elder-header
      [header]="'batchtracing.title' | translate"
      [subheader]="
        (groupTracedMaterials ? 'batchtracing.conf.grouped-view' : 'batchtracing.conf.single-view')
          | translate
      "
    >
    </elder-header>

    <span class="flex"></span>

    <mat-slide-toggle name="group-traced-materials" [(ngModel)]="groupTracedMaterials">
      {{ 'context.group' | translate }}
    </mat-slide-toggle>

    <!--    <mat-menu #menu="matMenu">-->
    <!--    </mat-menu>-->
  </div>
</ng-template>
